
import OnlineAppointmentComponent from "@/components/Shared/ViewResultCard/OnlineAppointment/OnlineAppointmentComponent";
export default OnlineAppointmentComponent;
